// extracted by mini-css-extract-plugin
export default {"advertDetailContactItem":"c-m_hp","advertDetailContactItem__link":"c-m_hq","advertDetailContactItem__stub":"c-m_hr"};